////
/// ============================================================================
/// COMPONENT / Popup
/// ============================================================================
///
/// @group components
////
export default () => {
    document.querySelectorAll(".js-popup").forEach(element => {
        element.addEventListener("click", event => {
            event.preventDefault();

            let width = element.dataset.width || 600;
            let height = element.dataset.height || 480;

            let params = [
                "scrollbars=" + element.dataset.scrollbars || "no",
                "width=" + width,
                "height=" + height,
                "top=" + (window.innerHeight / 2 - height / 2 + window.screenY),
                "left=" + (window.innerWidth / 2 - width / 2 + window.screenX),
            ].join(",");

            let popup = window.open(element.getAttribute("href"), '', params);

            if (window.focus) {
                popup.focus();
            }
        });
    });
};
